import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import home from "../image/home.mp4";
import guide from "../image/Guide.png";
import home2 from "../image/backgroundvideo.mp4";

import doc1 from "../image/image1.jpg";
import doc2 from "../image/image2.jpg";
import doc3 from "../image/image3.jpg";
import doc4 from "../image/image4.jpg";
import doc9 from "../image/image5.jpg";
import doc6 from "../image/image6.jpg";
import doc7 from "../image/image7.jpg";
import doc8 from "../image/image8.jpg";
import doc10 from "../image/image9.jpg";
import doc11 from "../image/image10.jpg";
import doc12 from "../image/image11.jpg";
import doc13 from "../image/image12.jpg";
import doc14 from "../image/image13.jpg";
import doc15 from "../image/image14.jpg";
import logo1 from "../image/logo1.png";
import logo2 from "../image/logo2.png";
import logo3 from "../image/logo3.png";
import logo4 from "../image/logo4.png";
import logo5 from "../image/logo5.jpg";
import logo6 from "../image/logo6.jpg";
import logo7 from "../image/logo7.jpg";

import SiYourtraveldottv from "../image/SiYourtraveldottv.png";
import backgroundImage from "../image/backgroundImage.JPG";
import fundofolha from "../image/fundofolha.jpg";
import blog1 from "../image/blog1.JPG";
import map from "../image/map.png";
import go from "../image/godf.png";
import ms from "../image/ms.png";
import mt from "../image/mt.png";
import pr from "../image/pr.png";
import ba from "../image/ba.png";
import mg from "../image/mg.png";
import sp from "../image/sp.png";

import Navbutton from "../navbutton/Navbutton";
import Counter from "../components/Counter";
import ScrollToTop from "../components/ScrollToTop";
import ServicesModal from "../components/ServicesModal";
import WhatsAppCTA from "../components/WhatsAppCTA";
import { buildEmailjsContactParams } from "../utils/emailjsContactParams";

import "./LandingV2.css";

function LandingV2() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isServicesModalOpen, setIsServicesModalOpen] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    if (window.emailjs) {
      window.emailjs.init("MUyvro6tDlg04hmtY");
    }
  }, []);

  const handleSubmitContact = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      if (!window.emailjs) {
        throw new Error(
          "EmailJS não está carregado. Verifique se o script foi adicionado no HTML."
        );
      }

      const templateParams = buildEmailjsContactParams({
        name,
        phone,
        email,
        message,
      });

      await window.emailjs.send("service_en3zec5", "template_xcfhqrg", templateParams);

      setSubmitStatus("success");
      setName("");
      setPhone("");
      setEmail("");
      setMessage("");
      setTimeout(() => setSubmitStatus(null), 5000);
    } catch (error) {
      console.error("Erro ao enviar mensagem:", error);
      setSubmitStatus("error");
      setTimeout(() => setSubmitStatus(null), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenServicesModal = (serviceId = null) => {
    setSelectedServiceId(serviceId);
    setIsServicesModalOpen(true);
  };

  const handleCloseServicesModal = () => {
    setIsServicesModalOpen(false);
    setSelectedServiceId(null);
  };

  const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7];

  return (
    <div className="App v2">
      <ScrollToTop />

      <header class="header">
        <a href="/" className="logo">
          <img
            src={SiYourtraveldottv}
            alt="Logo Hugão"
            style={{ height: "70px", width: "auto" }}
          />
        </a>

        <nav class="navbar">
          <a href="#home">Início</a>
          <a href="#about">Sobre</a>
          <a href="#services">Serviços</a>
          <a href="#doctors">Equipe</a>
          <a href="#reviews">Clientes</a>
          <a href="#blogs">Blog</a>
          <a href="#book">Contato</a>
        </nav>

        <div id="menu-btn">
          <Navbutton />
        </div>
      </header>

      {/* Section 1 (V2) */}
      <section class="home" id="home">
        <div className="video">
          <video src={home2} autoPlay loop muted></video>
        </div>

        <div class="content">
          <h3>
            Um <span className="v2-hero-error">ERRO</span> ambiental pode parar
            sua obra
          </h3>

          <p>
            Em obras de infraestrutura, falhas ambientais não são apenas ajustes
            - elas podem gerar multas, embargos e atrasos críticos no projeto.
          </p>

          <a href="#book" class="btn">
            Falar com Especialista em infraestrutura
            <span class="fas fa-chevron-right"></span>
          </a>
        </div>
      </section>

      {/* Section 2 (V2) */}
      <section className="v2-exec-control" id="execucao-controle">
        <div className="v2-exec-control-inner">
          <h1 className="heading">
            Muitas vezes, o problema não está no planejamento, mas na{" "}
            <span>execução</span> e no controle em campo.
          </h1>

          <div className="v2-exec-control-grid">
            <div className="v2-exec-control-bullets">
              <ul className="v2-exec-control-list">
                <li>Multas e penalidades ambientais</li>
                <li>Embargos e paralisações</li>
                <li>Exigências não cumpridas</li>
                <li>Falhas na execução por terceiros</li>
              </ul>
            </div>

            <div className="v2-exec-control-text">
              <p>
                Esses problemas são frequentes em projetos de infraestrutura com
                condicionantes ambientais exigentes.
              </p>
              <p>
                Sem uma gestão ambiental estruturada, o risco deixa de ser
                técnico e passa a impactar diretamente o andamento e o custo da
                obra.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3 (V2) */}
      <section className="infra-gain" id="infra-gain">
        <div className="infra-gain-inner">
          <div className="infra-gain-left">
            <span className="infra-gain-kicker">Redução de risco</span>
            <h2 className="infra-gain-title">Redução de risco ambiental na prática</h2>
            <p className="infra-gain-subtitle">Como a gente atua em campo</p>

            <blockquote className="infra-gain-quote">
              Reduzimos o risco operacional para que o ambiental não comprometa
              seu projeto.
            </blockquote>

            <a href="#book" className="btn infra-gain-cta">
              Eliminar riscos ambientais
              <span className="fas fa-chevron-right"></span>
            </a>
          </div>

          <div className="infra-gain-right">
            <article className="infra-gain-card">
              <div className="infra-gain-card-icon">
                <i className="fas fa-shield-alt" aria-hidden="true"></i>
              </div>
              <div>
                <h3>Prevenção de falhas</h3>
                <p>Identificamos riscos antes que virem problema.</p>
              </div>
            </article>

            <article className="infra-gain-card">
              <div className="infra-gain-card-icon">
                <i className="fas fa-tasks" aria-hidden="true"></i>
              </div>
              <div>
                <h3>Controle de execução</h3>
                <p>Garantimos que exigências ambientais sejam cumpridas em campo.</p>
              </div>
            </article>

            <article className="infra-gain-card">
              <div className="infra-gain-card-icon">
                <i className="fas fa-users-cog" aria-hidden="true"></i>
              </div>
              <div>
                <h3>Gestão de terceiros</h3>
                <p>Evitamos erros de fornecedores que podem gerar multas e embargos.</p>
              </div>
            </article>

            <article className="infra-gain-card">
              <div className="infra-gain-card-icon">
                <i className="fas fa-chart-line" aria-hidden="true"></i>
              </div>
              <div>
                <h3>Acompanhamento contínuo</h3>
                <p>Monitoramento ativo para manter conformidade ao longo da obra.</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Services (mesma estrutura da V1) */}
      <section
        className="services"
        id="services"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "#fff",
        }}
      >
        <h1 class="heading">
          {" "}
          Como apoiamos seu <span>projeto</span>{" "}
        </h1>

        <div class="box-container">
          <div class="box">
            <i class="fas fa-solid fa-file-contract"></i>
            <h3>Licenciamento Ambiental e Regularização </h3>
            <p>
              Obtenção de licenças prévias, de instalação ou de operação para
              empreendimentos diversos. Estudos de Impacto Ambiental (EIA),
              Relatórios de Impacto Ambiental (RIMA) e Relatórios Simplificados
              (RAS).
            </p>
            <button onClick={() => handleOpenServicesModal("laudos")} className="btn">
              Saiba mais <span className="fas fa-chevron-right"></span>
            </button>
          </div>

          <div class="box">
            <i class="fas fa-solid fa-tree"></i>
            <h3>Flora </h3>
            <p>
              Realizamos inventários florestais, elaboração de planos e documentos
              para Austorizações de Supressão Vegetal (ASV). Além de avaliar,
              identificar e mapear cobertura vegetal para recuperação de áreas
              degradadas.
            </p>
            <button onClick={() => handleOpenServicesModal("florestal")} className="btn">
              Saiba mais <span className="fas fa-chevron-right"></span>
            </button>
          </div>

          <div class="box">
            <i class="fas fa-solid fa-frog"></i>
            <h3>Fauna</h3>
            <p>
              Elaboração de Planos de Manejo da Fauna em Aeródromos (PMFA),
              Resgate, Afugentamento e Monitoramento de Fauna em áreas de impacto,
              Inventários de Biodiversidade e Monitoramento de Fauna Atropelada.
            </p>
            <button onClick={() => handleOpenServicesModal("fauna")} className="btn">
              Saiba mais <span className="fas fa-chevron-right"></span>
            </button>
          </div>

          <div class="box">
            <i class=" fas fa-solid fa-map"></i>
            <h3>Drones e Geoprocessamento</h3>
            <p>
              Empregamos drones e geoprocessamento para monitoramento ambiental,
              análises espaciais, mapas temáticos, zoneamentos e recuperação de
              áreas degradadas com precisão e inovação.
            </p>
            <button onClick={() => handleOpenServicesModal("drones")} className="btn">
              Saiba mais <span className="fas fa-chevron-right"></span>
            </button>
          </div>

          <div class="box">
            <i class="fas fa-solid fa-users"></i>
            <h3>Treinamentos e Capacitação </h3>
            <p>
              Oferecemos treinamentos especializados, incluindo PGR e PAE, manejo
              de fauna, resgate de espécies e educação ambiental, capacitando
              equipes, promovendo a preservação da biodiversidade e conscientização
              ambiental.
            </p>
            <button
              onClick={() => handleOpenServicesModal("levantamentos")}
              className="btn"
            >
              Saiba mais <span className="fas fa-chevron-right"></span>
            </button>
          </div>

          <div class="box">
            <i class="fas fa-solid fa-compass"></i>
            <h3>Capex Opex </h3>
            <p>
              Oferecemos consultoria em CAPEX e OPEX socioambiental, otimizando
              investimentos, reduzindo riscos legais e alinhando projetos às
              melhores práticas de sustentabilidade, licenciamento ambiental e
              monitoramento contínuo.
            </p>
            <button onClick={() => handleOpenServicesModal("capex")} className="btn">
              Saiba mais <span className="fas fa-chevron-right"></span>
            </button>
          </div>
        </div>
      </section>

      {/* Icons (igual V1) */}
      <section class="icons-container">
        <div class="icons">
          <i class="fas fa-user-tie"></i>
          <h3>
            +<Counter endValue={20} duration={2000} pauseTime={3000} startDelay={0} />
          </h3>
          <p>Parceiros </p>
        </div>

        <div class="icons">
          <i class="fas fa-users"></i>
          <h3>
            +<Counter endValue={100} duration={2000} pauseTime={3000} startDelay={0} />
          </h3>
          <p>Clientes Satisfeitos</p>
        </div>

        <div class="icons">
          <i class="fas fa-user-graduate"></i>
          <h3>
            +<Counter endValue={10} duration={2000} pauseTime={3000} startDelay={0} />
          </h3>
          <p>Anos de experiência</p>
        </div>

        <div class="icons">
          <i class="fas fa-map-marked-alt"></i>
          <h3>
            +<Counter endValue={100} duration={2000} pauseTime={3000} startDelay={0} />
          </h3>
          <p>Atendimento em todo o Brasil</p>
        </div>
      </section>

      {/* Team (igual V1) */}
      <section className="doctors" id="doctors">
        <h1 className="heading">
          {" "}
          Você não fica <span>perdido no processo</span>{" "}
        </h1>
        <p className="team-subtitle">
          Nossa equipe orienta cada etapa, evita erros comuns e garante que tudo seja feito
          corretamente desde o início.
        </p>

        <div className="team-container">
          {/* cards iguais à V1 */}
          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc1})` }} />
            </div>
            <div className="team-info">
              <h3>Emerson Machado</h3>
              <p className="team-role">
                Biólogo, especialista em meio ambiente & engenharia sanitária, gestão ambiental, Mestre em Produção Vegetal.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc2})` }} />
            </div>
            <div className="team-info">
              <h3>Omar Corrreia</h3>
              <p className="team-role">
                Biólogo com experiência em análise de dados, drones, novas tecnologias, gestão de projetos e fauna.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc3})` }} />
            </div>
            <div className="team-info">
              <h3>João Las Casas</h3>
              <p className="team-role">
                Geógrafo, especialista ambiental com experiência em supervisão, monitoramento, licenciamento, geoprocessamento, remediação e recuperação ambiental.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc4})` }} />
            </div>
            <div className="team-info">
              <h3>Angelo Gervásio</h3>
              <p className="team-role">
                Biólogo, mestre em biologia vegetal, com ampla experiência em identificação de espécies, inventários florestais, censo de vegetação e projetos de conservação.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc9})` }} />
            </div>
            <div className="team-info">
              <h3>Hugo Sanchez</h3>
              <p className="team-role">
                Biólogo, mestre em biologia vegetal, analista e desenvolvedor de sistemas, com experiência em Projetos ambientais e tecnologia da informação direcionadas ao meio ambiente.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc6})` }} />
            </div>
            <div className="team-info">
              <h3>Jéssica Karine</h3>
              <p className="team-role">
                Engenheira florestal com experiência em tecnologia da madeira, recuperação de ecossistemas e gestão ambiental.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc7})` }} />
            </div>
            <div className="team-info">
              <h3>Douglas Macedo</h3>
              <p className="team-role">
                Geógrafo, mestre em geografia, com ampla experiência em licenciamento e supervisão ambiental de obras de infraestrutura, atuando na coordenação de campo e implantação de programas ambientais.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc8})` }} />
            </div>
            <div className="team-info">
              <h3>Caíque Rocha</h3>
              <p className="team-role">
                Biólogo, mestre em ecologia, com experiência em inventários florestais, levantamento de fauna e análise de dados.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc10})` }} />
            </div>
            <div className="team-info">
              <h3>Dani Vasconcelos</h3>
              <p className="team-role">
                Médica veterinária, especialista em Herpetologia, com ampla experiência em estudos ambientais, licenciamento, monitoramento de fauna atropelada e coordenação de resgate de fauna. Atua também com manejo clínico de animais silvestres.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc11})` }} />
            </div>
            <div className="team-info">
              <h3>Flavio Trindade</h3>
              <p className="team-role">
                Biólogo, especialista em vigilância de saúde ambiental e sanitária, herpetólogo, identificador botânico, com ampla experiência em inventários florestais.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc13})` }} />
            </div>
            <div className="team-info">
              <h3>Rebecca Lyan</h3>
              <p className="team-role">
                Designer especializada em UX, conteúdo digital e branding, criando materiais visuais e estratégias que fortalecem a presença digital de empresas ambientais e comunicam seus valores de sustentabilidade e inovação.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc15})` }} />
            </div>
            <div className="team-info">
              <h3>Grenda Alves</h3>
              <p className="team-role">
                Engenheira ambiental, com MBA em Gestão de Projetos e sólida experiência em obras de infraestrutura, licenciamento e gestão ambiental. Atuação em indicadores, ESG, PGR/PGRCC, auditorias, supervisão de obras e implementação de soluções sustentáveis em empreendimentos de grande porte.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc12})` }} />
            </div>
            <div className="team-info">
              <h3>Thales Nunes</h3>
              <p className="team-role">
                Biólogo, mestre em biologia vegetal, com ampla experiência em Educação Ambiental, Inventário Florestal e identificação botânica.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="team-image-wrapper">
              <div className="team-image" style={{ backgroundImage: `url(${doc14})` }} />
            </div>
            <div className="team-info">
              <h3>Raul Rodrigues</h3>
              <p className="team-role">
                Biólogo com experiência em inventários de flora, geoprocessamento e trabalhos de campo, atuando com SIG, análise espacial, resgate de fauna e flora e elaboração de relatórios ambientais. Perfil analítico, proativo e com vivência em projetos socioambientais e educação ambiental.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Map (igual V1) */}
      <section className="team-section">
        <h1 class="heading">
          {" "}
          O Time que move a <span>Biolink</span>{" "}
        </h1>
        <p>Trabalho em equipe é a chave!</p>

        <div className="map-container">
          <div className="map-central">
            <img src={map} alt="Mapa do Brasil" />
          </div>
          <div className="state go">
            <img src={go} alt="Goiás" />
          </div>
          <div className="state ms">
            <img src={ms} alt="Mato Grosso do Sul" />
          </div>
          <div className="state mt">
            <img src={mt} alt="Mato Grosso" />
          </div>
          <div className="state pr">
            <img src={pr} alt="Paraná" />
          </div>
          <div className="state ba">
            <img src={ba} alt="Bahia" />
          </div>
          <div className="state mg">
            <img src={mg} alt="Minas Gerais" />
          </div>
          <div className="state sp">
            <img src={sp} alt="São Paulo" />
          </div>
        </div>

        <p className="description">
          A Biolink além de sua equipe, também conta com uma rede de consultores associados para o
          atendimento em todas as regiões do país.
        </p>
      </section>

      {/* Section 7 (V2) */}
      <section className="v2-experience" id="experience">
        <h1 className="heading">
          Experiência em cenários de <span>alta exigência ambiental</span>
        </h1>
        <p className="v2-experience-subtitle">
          Atuamos em projetos onde falhas ambientais impactam diretamente o cronograma, o custo e a
          continuidade da operação.
        </p>

        <div className="v2-experience-grid">
          <div className="v2-experience-card">
            <span className="v2-experience-icon" aria-hidden="true">
              <i className="fas fa-clipboard-check"></i>
            </span>
            Obras com condicionantes ambientais
          </div>
          <div className="v2-experience-card">
            <span className="v2-experience-icon" aria-hidden="true">
              <i className="fas fa-binoculars"></i>
            </span>
            Projetos com fiscalização ativa
          </div>
          <div className="v2-experience-card">
            <span className="v2-experience-icon" aria-hidden="true">
              <i className="fas fa-people-carry"></i>
            </span>
            Execução com múltiplos fornecedores
          </div>
          <div className="v2-experience-card">
            <span className="v2-experience-icon" aria-hidden="true">
              <i className="fas fa-gavel"></i>
            </span>
            Operações com risco regulatório
          </div>
        </div>
      </section>

      {/* Section 8 (V2) - logos */}
      <section className="reviews" id="reviews">
        <h1 className="heading">
          Atuação em <span>projetos de infraestrutura</span>
        </h1>
        <p className="reviews-subtitle">
          Focados em projetos onde o risco ambiental não pode ser tratado como secundário.
        </p>

        <div className="clients-grid">
          {logos.map((logo, index) => (
            <div key={index} className="client-card">
              <div className="client-logo-wrapper">
                <img src={logo} alt={`Cliente ${index + 1}`} className="client-logo" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* About (igual V1, na mesma posição antes do Blog conforme ajuste atual) */}
      <section class="about" id="about">
        <div className=" Nelson">
          <h1 class="heading">
            {" "}
            <span>Sobre</span> Nós{" "}
          </h1>

          <div class="row">
            <div class="image">
              <video src={home} controls autoPlay loop muted></video>
            </div>

            <div class="content">
              <h3>
                Biolink: Inovação e Excelência em Consultoria Ambiental para um Futuro Sustentável
              </h3>
              <p>
                Em um cenário de desenvolvimento acelerado, a infraestrutura demanda soluções
                ambientais rápidas e eficazes. Na Biolink, aliamos expertise técnica à tecnologia de
                ponta para entregar resultados precisos e otimizar o sucesso do seu empreendimento.
              </p>
              <p>
                Nossa equipe multidisciplinar - composta por geógrafos, biólogos, engenheiros
                florestais, programadores e especialistas em drones – possui ampla experiência em
                projetos de infraestrutura, transformando desafios em soluções inovadoras. Com a
                Biolink, seu projeto ganha agilidade, eficiência e valor agregado.
              </p>
              <a href="#book" class="btn">
                Fale com um Especialista em Infraestrutura{" "}
                <span class="fas fa-chevron-right"></span>{" "}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Blog (igual V1) */}
      <section className="blogs" id="blogs">
        <h1 className="heading">
          {" "}
          Nosso <span>Blog</span>{" "}
        </h1>
        <p className="blog-subtitle">
          Conhecimento, experiências e novidades sobre sustentabilidade e consultoria ambiental
        </p>

        <div className="blog-container">
          <div className="blog-card">
            <div className="blog-image-wrapper">
              <img src={blog1} alt="Blog post" className="blog-image" />
              <div className="blog-overlay"></div>
            </div>
            <div className="blog-content">
              <div className="blog-meta">
                <span className="blog-date">
                  <i className="fas fa-calendar"></i> 15 de Janeiro, 2025
                </span>
                <span className="blog-author">
                  <i className="fas fa-user"></i> Biolink
                </span>
              </div>
              <h3 className="blog-title">Bem-vindos ao Blog da Biolink Soluções Ambientais!</h3>
              <p className="blog-excerpt">
                Inauguramos este espaço com entusiasmo para compartilhar conhecimento, experiências
                e novidades sobre sustentabilidade e consultoria ambiental, promovendo
                conscientização, troca de ideias e soluções para um futuro mais sustentável e
                responsável.
              </p>
              <Link to="/Blog1" className="blog-link">
                Ler mais <span className="fas fa-chevron-right"></span>
              </Link>
            </div>
          </div>

          <div className="blog-card">
            <div className="blog-image-wrapper">
              <img src={blog1} alt="Blog post" className="blog-image" />
              <div className="blog-overlay"></div>
            </div>
            <div className="blog-content">
              <div className="blog-meta">
                <span className="blog-date">
                  <i className="fas fa-calendar"></i> 16 de Janeiro, 2025
                </span>
                <span className="blog-author">
                  <i className="fas fa-user"></i> Biolink
                </span>
              </div>
              <h3 className="blog-title">Due Diligence Ambiental: Entenda Sua Importância e Benefícios</h3>
              <p className="blog-excerpt">
                Due Diligence Ambiental identifica riscos e oportunidades em empreendimentos,
                garantindo conformidade legal, sustentabilidade e mitigação de impactos ambientais,
                promovendo decisões estratégicas mais seguras e responsáveis.
              </p>
              <Link to="/Blog2" className="blog-link">
                Ler mais <span className="fas fa-chevron-right"></span>
              </Link>
            </div>
          </div>

          <div className="blog-card">
            <div className="blog-image-wrapper">
              <img src={blog1} alt="Blog post" className="blog-image" />
              <div className="blog-overlay"></div>
            </div>
            <div className="blog-content">
              <div className="blog-meta">
                <span className="blog-date">
                  <i className="fas fa-calendar"></i> 17 de Janeiro, 2025
                </span>
                <span className="blog-author">
                  <i className="fas fa-user"></i> Biolink
                </span>
              </div>
              <h3 className="blog-title">A importância e os riscos do transporte de produtos perigosos</h3>
              <p className="blog-excerpt">
                O transporte de produtos perigosos envolve riscos significativos à segurança e ao
                meio ambiente. Sua gestão eficaz requer planejamento, conformidade legal, capacitação,
                práticas adequadas e medidas de emergência para minimizar impactos e acidentes.
              </p>
              <Link to="/Blog3" className="blog-link">
                Ler mais <span className="fas fa-chevron-right"></span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Section 10 (V2) - CTA final / Form */}
      <section className="contact" id="book">
        <h1 className="heading">
          <span>Reduza os riscos ambientais</span> do seu projeto
        </h1>
        <p className="contact-subtitle">
          Identificamos os principais pontos de risco e orientamos as ações necessárias para manter
          sua obra em conformidade.
        </p>

        <div className="contact-container">
          <div className="contact-image-wrapper">
            <img src={guide} alt="Contato Biolink" className="contact-image" />
          </div>

          <form className="contact-form" onSubmit={handleSubmitContact}>
            <h3 className="contact-form-title">Eliminar riscos ambientais</h3>
            <p className="contact-form-description">
              Preencha o formulário e nossa equipe retorna com orientação objetiva para reduzir risco
              ambiental e manter a obra andando.
            </p>

            <div className="form-group">
              <input
                type="text"
                placeholder="Seu nome completo"
                className="form-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <input
                type="tel"
                placeholder="Seu telefone (com DDD)"
                className="form-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                placeholder="Seu melhor email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <textarea
                placeholder="Conte-nos sobre o projeto (tipo de obra, fase, principal risco)..."
                className="form-textarea"
                rows="5"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                disabled={isSubmitting}
              ></textarea>
            </div>

            {submitStatus === "success" && (
              <div className="form-message form-message-success">
                <i className="fas fa-check-circle"></i>
                Mensagem enviada com sucesso! Entraremos em contato em breve.
              </div>
            )}

            {submitStatus === "error" && (
              <div className="form-message form-message-error">
                <i className="fas fa-exclamation-circle"></i>
                Erro ao enviar mensagem. Tente novamente ou entre em contato pelo WhatsApp.
              </div>
            )}

            <button type="submit" className="contact-submit-btn" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Enviando...
                </>
              ) : (
                <>
                  Eliminar riscos ambientais
                  <span className="fas fa-chevron-right"></span>
                </>
              )}
            </button>
          </form>
        </div>
      </section>

      <section
        class="footer"
        style={{
          background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "#fff",
        }}
      >
        <div class="box-container">
          <div class="box">
            <h3>Navegue</h3>
            <a href="#home">
              <i class="fas fa-chevron-right"></i> Início
            </a>
            <a href="#about">
              <i class="fas fa-chevron-right"></i> Sobre
            </a>
            <a href="#services">
              <i class="fas fa-chevron-right"></i> Serviços
            </a>
            <a href="#doctors">
              <i class="fas fa-chevron-right"></i> Equipe
            </a>
            <a href="#book">
              <i class="fas fa-chevron-right"></i> Iniciar conversa
            </a>
            <a href="#blogs">
              <i class="fas fa-chevron-right"></i> Blog
            </a>
          </div>

          <div class="box">
            <h3>Nossos serviços</h3>
            <a href="#services">
              <i class="fas fa-chevron-right"></i> Licenciamento Ambiental e Regularização
            </a>
            <a href="#services">
              <i class="fas fa-chevron-right"></i> Flora
            </a>
            <a href="#services">
              <i class="fas fa-chevron-right"></i> Fauna
            </a>
            <a href="#services">
              <i class="fas fa-chevron-right"></i> Drones e Geoprocessamento
            </a>
            <a href="#services">
              <i class="fas fa-chevron-right"></i> Treinamentos e Capacitação
            </a>
            <a href="#services">
              <i class="fas fa-chevron-right"></i> Capex Opex
            </a>
          </div>

          <div class="box">
            <h3>Contato </h3>
            <a href=" https://wa.me/5534999203789?text=Gostaria%20de%20atendimento%20estava%20navegando%20">
              <i class="fas fa-phone"></i> (34) 9 9920-3789
            </a>
            <a href="https://wa.me/5511986321639?text=Gostaria%20de%20atendimento%20estava%20navegando%20no%20site!%20">
              <i class="fas fa-phone"></i> (11) 9 8632-1639
            </a>
            <a href="mailto:emerson@biolinksolucoes.com.br?subject=Assunto%20do%20E-mail&body=Mensagem%20inicial">
              <i class="fas fa-envelope"></i> emerson@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i class="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i class="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais
            </a>
          </div>

          <div class="box">
            <h3>Conecte-se conosco!</h3>
            <a href="https://www.instagram.com/biolink_ambiental/">
              <i class="fab fa-instagram"></i> instagram
            </a>
            <a href="https://www.linkedin.com/company/biolink-ambiental/posts/?feedView=all">
              <i class="fab fa-linkedin"></i> linkedin
            </a>
          </div>
        </div>

        <div class="credit">
          Criado por <span><a href="/"> Biolink </a></span> | ©Todos os direitos reservados.
        </div>
      </section>

      <ServicesModal
        isOpen={isServicesModalOpen}
        onClose={handleCloseServicesModal}
        selectedServiceId={selectedServiceId}
      />
      <WhatsAppCTA />
    </div>
  );
}

export default LandingV2;

